import { useQuery } from '@tanstack/react-query';
import type { ProfileResponse } from '@app/shared';
import { ru, type Dictionary } from './ru';

export type { Dictionary };

const BY_LANG: Record<string, Dictionary> = { ru };

/** Dictionary for a language; Russian when the language is unknown or not given. */
export function dictionary(lang?: string | null): Dictionary {
  return (lang && BY_LANG[lang]) || ru;
}

/** Dictionary of the person who opened the app (from the cached profile). */
export function useT(): Dictionary {
  const { data } = useQuery<ProfileResponse>({ queryKey: ['profile'], enabled: false });
  return dictionary(data?.user.languageCode);
}
